// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/multiple-buttons/assets/scss/multiple-buttons.scss
// module id = 100
// module chunks = 25